import React, { useState, useEffect } from 'react'
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import
{
    TextField, InputAdornment, Paper, Checkbox, Box, Button
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import UserCheckList from '../../sharedcomponents/userList/userCheckList';
const buttonContent = {
    margin: '16px 8px 0',
    // width: '150px',
    float: 'right'
}

export default function UserListDialog(props)
{

    const [users, setUsers] = useState([])
    const [selected, setSelected] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [allCheck, setAllCheck] = useState(false);

    useEffect(() =>
    {
        if (props.users.length > 0 && users.length == 0)
        {
            setUsers(props.users);
        }
    }, [props.users])

    const checkSelectedUsers = (selectedUsers) =>
    {
        setSelected(selectedUsers);
    }
    const handleOnSearchChange = (val) =>
    {

        let value = val.replace(/^\s+/g, '');
        setSearch(value);
        let newUsers = [...props.users];
        if (value.length > 0)
        {
            newUsers = props.users.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                (x.roleName !== null && x.roleName.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
                (x.userTags !== null && x.userTags.toLowerCase().indexOf(value.toLowerCase()) > -1)
            )
            setUsers(newUsers)
        } else
        {
            setUsers([...props.users])
        }


    }
    const handleAllCheck = () =>
    {
        let data = [];
        users.map((item) =>
        {
            data.push(item.userID);
        });
        if (allCheck === false)
        {
            setAllCheck(true)
            setSelected(data)
        } else
        {
            setAllCheck(false)
            setSelected([])
        }
    }
    const renderDialogContent = () => (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',
                alignItems: 'left',
            }}>
                {!props.isView && (props.selectAllCheckBox && <Checkbox
                    edge="start"
                    checked={allCheck}
                    onChange={handleAllCheck}
                    disableRipple
                    sx={{ ml: "4px" }}
                />)}
                <TextField
                    size="small"
                    fullWidth={true}
                    placeholder="Search Individuals"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    value={search}
                    onChange={(event) => handleOnSearchChange(event.target.value)}
                />
            </Box>
            <Paper>
                <UserCheckList
                    data={users}
                    checkUsers={checkSelectedUsers}
                    selectedUsers={selected}
                    showRole={true}
                    sentInvitationList={props.sentInvitationList}
                />
            </Paper>


        </>
    );
    const handleAddParticipant = () =>
    {
        props.addParticipants(selected)
        if (selected.length > 0)
            setLoading(true);
    }
    const handleDeleteParticipant = () =>
    {
        props.deleteParticipants(selected)
        if (selected.length > 0)
            setLoading(true);
    }
    const renderDialogActions = () => (
        <ButtonContainer
            loading={loading}
            handleClick={!props.isView ? handleAddParticipant : handleDeleteParticipant}
            handleCancel={props.handleClose}
            buttonText={!props.isView ? 'Add' : 'Delete'}
        />
    );
    const renderDialogActions2 = () =>
    (
        <Box style={buttonContent}>
            <Button
                variant="outlined"
                onClick={props.handleClose}
                sx={{
                    width: '100%'
                }}>
                Close
            </Button>
        </Box>
    )
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={props.sentInvitationList != undefined ? renderDialogActions2 : renderDialogActions}
        />
    )
}
